module.exports = __webpack_public_path__ + "assets/img/18_1866_big.5515927d.jpg";